import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { colors } from "./Colors";

const Pagination = ({ currentPage, totalPages, onPageChange, total, startIndex, endIndex, t }) => {
  return (
    <div
      className="pagination-container"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        margin: "8px 0",
        gap: 8,
        flexWrap: "nowrap",
        width: "100%",
      }}
    >
      {/* Showing count */}
      <small
        style={{
          color: colors.spareBlue,
          fontSize: 12,
          whiteSpace: "nowrap",
          fontFeatureSettings: '"tnum" 1',
          lineHeight: 1.2,
        }}
      >
        {t("pagination:showingRange", {
          start: startIndex + 1,
          end: endIndex,
          total,
        })}
      </small>

      {/* Pager buttons */}
      <div style={{ display: "inline-flex", gap: 4, alignItems: "center", whiteSpace: "nowrap" }}>
        <button
          type="button"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          aria-label={t("pagination:prevPageAria")}
          style={{
            border: `1px solid ${colors.darkBlue}`,
            borderRadius: 10,
            color: colors.darkBlue,
            background: colors.white,
            cursor: currentPage === 1 ? "not-allowed" : "pointer",
            padding: "0 8px",
            height: 28,
            fontSize: 13,
            lineHeight: 1,
          }}
        >
          ←
        </button>

        <span
          style={{
            padding: "0 4px",
            fontSize: 12,
            whiteSpace: "nowrap",
            fontFeatureSettings: '"tnum" 1',
            lineHeight: 1.2,
          }}
        >
          {t("pagination:pageXofY", {
            current: currentPage,
            total: totalPages,
          })}
        </span>

        <button
          type="button"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          aria-label={t("pagination:nextPageAria")}
          style={{
            border: `1px solid ${colors.darkBlue}`,
            borderRadius: 10,
            color: colors.darkBlue,
            background: colors.white,
            cursor: currentPage === totalPages ? "not-allowed" : "pointer",
            padding: "0 8px",
            height: 28,
            fontSize: 13,
            lineHeight: 1,
          }}
        >
          →
        </button>
      </div>
    </div>
  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  total: PropTypes.number.isRequired,
  startIndex: PropTypes.number.isRequired,
  endIndex: PropTypes.number.isRequired,
  t: PropTypes.func, // injected by withTranslation
};

export default withTranslation(["pagination"])(Pagination);
